import React, { useState, useEffect, useCallback, useMemo } from "react";
// 3rd party component
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
  ColumnToggle,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";

// custom component
import TableExport from "app/views/custom/components/Export/TableExport";
import { SetPermission } from "../SetPermission/Permissions";
import { Fragment } from "react";

import { useSelector, useDispatch } from "react-redux";
import { filterActionAdd } from "app/_pages/_healthSafetyEnvironment/TrainingManagement/Assign/ReducerForAssign";
import { Link, useLocation } from "react-router-dom";
import MultiSelectWithCheckbox from "../SearchableSelect/MultiSelectCkeckOption";
import { UserDataActions } from "app/redux/actions/userData.action";
import MultiSelectTwo from "../SearchableSelect/MultiSelectTwo";
import { IoIosArrowDropdown } from "react-icons/io";
import { customColumnMatch } from "app/_helpers/helper";
import BackBtn from "../CommanComponents/BackBtn";
import { Button } from "react-bootstrap";
const { SearchBar } = Search;
const { ToggleList } = ColumnToggle;

export const SearchBootstrapTable = ({
  data,
  columns,
  downloadPermission,
  searchFlag,
  tableDownloadFlag,
  selectRow,
  tableToolbarBeforeView,
  tableToolbarView,
  tableName,
  fullData = false,
  className,
  tableBeforeSearch,
  batchButtonView,
  sort,
  onSort,
  remote,
  onTableChange,
  CustomSearch,
  expandRow,
  isMobileScreen,
  tableKey,
  searchKey,
  defaultHideColumn,
  hideExportWord = true,
  rowStyle = () => {},
  isNoPagination = false,
}) => {
  const [dataSizeChange, setDataSizeChange] = useState(1);

  const paginationOptions = {
    // custom: true,
    sizePerPage: isMobileScreen ? 50 : 10,
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "Next page",
    prePageTitle: "Pre page",
    firstPageTitle: "First page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: Array.isArray(data) ? data.length : 0,
    onPageChange: (dataSize) => {
      // console.log("pageChange", dataSize);
      setDataSizeChange(dataSize);
    },
    onSizePerPageChange: (sizePerPage, page) => {
      setPageSizeChange(sizePerPage);
    },
  };

  const [pageSizeChange, setPageSizeChange] = useState(paginationOptions.sizePerPage);

  const { pathname } = useLocation();
  const filterStatus = useSelector((state) => state.filterReducerTraining);
  //const [hideColumn, setHideColumn] = useState(JSON.parse(localStorage.getItem('selectedColumn')) || {})
  const dispatchFunction = useDispatch();
  const [searchFilter, setSearchFilter] = useState("");

  const onSearchFilter = (props) => {
    // paginationOptions.page = 1;
    paginationOptions.pageStartIndex = 1;
    setDataSizeChange(1);
    let value = props?.searchProps?.searchText;
    if (searchFilter?.search !== props?.searchProps?.searchText) setSearchFilter(value);
  };

  // console.log("dataSizeChange", dataSizeChange);
  // // const finalPaginationOptions = useMemo(() => {
  // //   return { ...paginationOptions, pageStartIndex: dataSizeChange };
  // // }, [dataSizeChange, paginationOptions]);

  // console.log("d========", paginationOptions);

  var obj = {};
  obj[searchKey] = searchFilter;
  useEffect(() => {
    dispatchFunction(searchKey ? filterActionAdd(obj) : filterActionAdd());
  }, [searchFilter]);
  return (
    <ToolkitProvider
      striped
      keyField="id"
      data={data}
      // columns={columns}
      columns={columns
        .filter((d) => !d?.isExcelOnly)
        .map((d, idx) => {
          // If dataField is "sid", apply a formatter
          if (d.dataField === "sid") {
            return {
              ...d,
              formatter: (cell, row, rowIndex, formatExtraData) => {
                return 1 + rowIndex + (dataSizeChange - 1) * pageSizeChange;
              },
            };
          } else {
            return d;
          }
        })}
      columnToggle
      search={{
        onColumnMatch: customColumnMatch,
        searchFormatted: true,
        defaultSearch: searchKey ? filterStatus && filterStatus[searchKey] : "",
      }}
    >
      {(props) => {
        return (
          <>
            {onSearchFilter(props)}
            {tableBeforeSearch && tableBeforeSearch()}

            <div
              className={`d-flex align-items-center justify-content-between ${
                !isMobileScreen && "pb-3"
              }`}
            >
              <div className="d-flex align-items-center justify-content-between">
                {searchFlag !== false &&
                  (CustomSearch ? (
                    <CustomSearch />
                  ) : (
                    <SearchBar {...props.searchProps} className="mb-0 dataTblSearch" />
                  ))}

                {tableToolbarBeforeView && tableToolbarBeforeView()}
              </div>
              <div className="d-flex">
                {batchButtonView && batchButtonView()}
                <div className="d-flex hideShow">
                  {tableKey && (
                    <>
                      <div class="d-flex hideShowColumnDiv">
                        <h3 class="hideShowColumn">Columns</h3>
                        <div style={{ color: "#ced4da" }}>
                          <IoIosArrowDropdown size={20} />
                        </div>
                      </div>
                      <CustomToggleList
                        {...props.columnToggleProps}
                        tableKey={tableKey}
                        defaultHideColumn={defaultHideColumn}
                      />
                    </>
                  )}
                  <div className="btn-toolbar">
                    {tableToolbarView && tableToolbarView()}

                    {tableDownloadFlag !== false && (
                      <Fragment>
                        {downloadPermission ? (
                          <SetPermission
                            permission={downloadPermission}
                            data={
                              <TableExport
                                tableName={tableName || "CompleteOwnerPaymentHistory"}
                                dataColumn={columns?.filter((d) => !d?.isTableOnly)}
                                renderData={data}
                                searchText={props.searchProps.searchText}
                                fullData={fullData}
                                hideExportWord={hideExportWord}
                              ></TableExport>
                            }
                          />
                        ) : (
                          <TableExport
                            tableName={tableName || "CompleteOwnerPaymentHistory"}
                            dataColumn={columns?.filter((d) => !d?.isTableOnly)}
                            renderData={data}
                            searchText={props.searchProps.searchText}
                            fullData={fullData || false}
                            hideExportWord={hideExportWord}
                          ></TableExport>
                        )}
                      </Fragment>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className={className || ""}>
              <BootstrapTable
                rowStyle={rowStyle}
                {...props.baseProps}
                data={props.baseProps.data.map((d, idx) => {
                  return { ...d, sid: idx + 1 };
                })}
                bootstrap4
                expandRow={expandRow}
                headerClasses={"tableTh"}
                pagination={isNoPagination ? false : paginationFactory(paginationOptions)}
                onDataSizeChange={(dataSize) => {
                  setDataSizeChange(1);
                }}
                noDataIndication={"Table is empty"}
                {...(() => {
                  const extraPropsToOverwriteIfExists = {};

                  if (selectRow) extraPropsToOverwriteIfExists.selectRow = selectRow;
                  if (remote) extraPropsToOverwriteIfExists.remote = remote;
                  if (sort) extraPropsToOverwriteIfExists.sort = sort;
                  if (onTableChange)
                    extraPropsToOverwriteIfExists.onTableChange = onTableChange;

                  return extraPropsToOverwriteIfExists;
                })()}
              />
            </div>
          </>
        );
      }}
    </ToolkitProvider>
  );
};

export const CustomToggleList = ({
  columns,
  onColumnToggle,
  toggles,
  tableKey,
  defaultHideColumn,
}) => {
  const { TOGGLE_COLUMN } = UserDataActions;
  const dispatch = useDispatch();
  const columnFields = useSelector((state) => {
    const finalArray = state.userData?.columnFields?.[tableKey];
    return finalArray || [];
  });
  const onChange = useCallback(
    (selectedSites) => {
      // Select All Logic
      // const emptyAll = selectedSites.length === 0;
      // const selectAll = selectedSites.length === columns.length;

      // if (emptyAll || selectAll) {
      //   for (const key in toggles) {
      //     const element = toggles[key];
      //     if ((element && emptyAll) || (!element && selectAll)) onColumnToggle(key);
      //   }

      //   return;
      // }

      // rest column logic
      const selectedSitesName = selectedSites.map((d) => d.value);
      const toggleSitesName = Object.keys(toggles).filter((d) => toggles[d]);

      const difference = selectedSitesName
        .filter((x) => !toggleSitesName.includes(x))
        .concat(toggleSitesName.filter((x) => !selectedSitesName.includes(x)));

      difference.map((d) => !columnFields?.includes(d) && columnFields?.push(d));
      const finalColumnFields = columnFields?.filter(
        (d) => !selectedSitesName?.includes(d)
      );
      dispatch(TOGGLE_COLUMN({ [tableKey]: finalColumnFields }));

      for (const iterator of difference) {
        onColumnToggle(iterator);
      }
      // if (difference.length === 1) onColumnToggle(difference[0]);
    },
    [TOGGLE_COLUMN, dispatch, onColumnToggle, columnFields, tableKey, toggles]
  );

  useEffect(() => {
    if (!columnFields?.length) return;
    const selected = columns
      .filter((c) => !columnFields.includes(c.dataField))
      .map((c) => ({ label: c.text, value: c.dataField }));
    onChange(selected);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [columns]);

  useEffect(() => {
    if (!defaultHideColumn) return;
    // if (!columnFields?.includes(defaultHideColumn[0])) {
    defaultHideColumn.map(
      (column) => !columnFields?.includes(column) && columnFields.push(column)
    );
    console.log("++++++++++++++--------", columnFields);
    // }
  }, []);

  columnFields.forEach((e) => {
    toggles[e] = false;
  });
  return (
    <div className="btn-group btn-group-toggle btn-group-vertical" data-toggle="buttons">
      <MultiSelectTwo
        options={columns.map((column) => ({
          label: column.text,
          value: column.dataField,
          disabled:
            Object.keys(toggles).filter((d) => toggles[d])?.length === 1 &&
            column.dataField === Object.keys(toggles).find((d) => toggles[d])
              ? true
              : false,
        }))}
        value={Object.keys(toggles)
          .filter((d) => toggles[d])
          .map((id) => {
            const found = columns.find((site) => site.dataField === id);
            return found ? { label: found.text, value: found.dataField } : null;
          })
          .filter((d) => !!d)}
        onChange={onChange}
        hasSelectAll={false}
        className="tableKey"
      />
    </div>
  );
};

export default SearchBootstrapTable;
